import { render, staticRenderFns } from "./BuddhismClaim.vue?vue&type=template&id=490ce21b&scoped=true"
import script from "./BuddhismClaim.vue?vue&type=script&lang=js"
export * from "./BuddhismClaim.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490ce21b",
  null
  
)

export default component.exports